/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Feedback_CloseInputs */

const en_feedback_close = /** @type {(inputs: Feedback_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Close`)
};

const zh_hans1_feedback_close = /** @type {(inputs: Feedback_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`关闭`)
};

const pt_br2_feedback_close = /** @type {(inputs: Feedback_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fechar`)
};

const es_feedback_close = /** @type {(inputs: Feedback_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cerrar`)
};

const fr_feedback_close = /** @type {(inputs: Feedback_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fermer`)
};

const de_feedback_close = /** @type {(inputs: Feedback_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schließen`)
};

const ru_feedback_close = /** @type {(inputs: Feedback_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Закрыть`)
};

const it_feedback_close = /** @type {(inputs: Feedback_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chiudi`)
};

/**
* | output |
* | --- |
* | "Close" |
*
* @param {Feedback_CloseInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const feedback_close = /** @type {((inputs?: Feedback_CloseInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Feedback_CloseInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_feedback_close(inputs)
	if (locale === "pt-BR") return pt_br2_feedback_close(inputs)
	if (locale === "es") return es_feedback_close(inputs)
	if (locale === "fr") return fr_feedback_close(inputs)
	if (locale === "de") return de_feedback_close(inputs)
	if (locale === "ru") return ru_feedback_close(inputs)
	if (locale === "it") return it_feedback_close(inputs)
	return en_feedback_close(inputs)
});